import { Component } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent {
  username = '';
  password = '';
  error = '';
  menuItems: any[] = [];

  constructor(private authService: AuthService, private router: Router) { }

  onLogin(): void {
    this.authService.login({ username: this.username, password: this.password }).subscribe({
      next: (res) => {
        this.router.navigate(['/']); // go to home
      },
      error: () => {
        this.error = 'Invalid login';
      }
    });
  }

}
